import { routes } from "../../../constants";
import { baseRouteMaker } from "../../../constants/routeConsts";
import { t } from "i18next";

export const useSubscriptionsAndAddonsMenuUtils = () => {
  const tempMenuGroup = [];

  /* menuItemSubscriptions */
  const menuItemSubscriptions = {
    id: "subscriptions",
    title: t("AppModuleNames.Provider.Subscriptions"),
    url: baseRouteMaker(routes.SERVICE_PROVIDER_SUBSCRIPTIONS),
  };
  tempMenuGroup.push(menuItemSubscriptions);
  /* menuItemSubscriptions */

  /* menuItemActivePlan */
  const menuItemActivePlan = {
    id: "active-plan",
    title: t("Modules.Subscriptions.activePlan"),
    url: baseRouteMaker(routes.SERVICE_PROVIDER_SUBSCRIPTIONS_ACTIVE_PLAN),
  };
  tempMenuGroup.push(menuItemActivePlan);
  /* menuItemActivePlan */

  /* menuItemSubscriptionPlanHistory */
  const menuItemSubscriptionPlanHistory = {
    id: "subscriptions-plan-history",
    title: t("Modules.Subscriptions.subHistory"),
    url: baseRouteMaker(routes.SERVICE_PROVIDER_SUBSCRIPTIONS_PLAN_HISTORY),
  };
  tempMenuGroup.push(menuItemSubscriptionPlanHistory);
  /* menuItemSubscriptionPlanHistory */

  return tempMenuGroup;
};
